/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `0` - CREATE_TASK_WITH_SUBTASK_RECS
 * * `1` - MAKE_A_TASK
 * * `2` - SET_A_PROFILE_PICTURE
 * * `3` - BRAINSTORM_WITH_AI
 * * `4` - DOWNLOAD_THE_APPS
 * * `5` - INVITE_TEAMMATES
 * * `6` - CHECKLIST_COMPLETED
 * * `7` - TRIAL_STARTED
 * * `8` - TRIAL_ENDED
 * * `9` - PLAN_WITH_AI
 * * `10` - SWITCH_TO_DESKTOP
 * * `11` - WATCH_THE_VIDEO
 * * `12` - USE_AI_CHAT
 * * `13` - START_BUILD_MODE
 * * `14` - SET_UP_AGENT
 * * `15` - TRY_A_TEAM_CHAT
 * * `16` - CHAT_WITH_YOUR_TEAM
 */
export enum TutorialName {
  CREATE_TASK_WITH_SUBTASK_RECS = 0,
  MAKE_A_TASK = 1,
  SET_A_PROFILE_PICTURE = 2,
  BRAINSTORM_WITH_AI = 3,
  DOWNLOAD_THE_APPS = 4,
  INVITE_TEAMMATES = 5,
  CHECKLIST_COMPLETED = 6,
  TRIAL_STARTED = 7,
  TRIAL_ENDED = 8,
  PLAN_WITH_AI = 9,
  SWITCH_TO_DESKTOP = 10,
  WATCH_THE_VIDEO = 11,
  USE_AI_CHAT = 12,
  START_BUILD_MODE = 13,
  SET_UP_AGENT = 14,
  TRY_A_TEAM_CHAT = 15,
  CHAT_WITH_YOUR_TEAM = 16,
}
